// i18n area 'hci' — locale ru-RU (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/hci.ru-RU.meta.json.
import type { enUS } from './hci'

export const ruRU: typeof enUS = {
  hci: {
    ceph: {
      title: 'Кластеры Ceph',
      createButton: 'Создать кластер Ceph',
      emptyTitle: 'Нет управляемых кластеров Ceph',
      emptyBody: 'TVirt развертывает Ceph на узлах-участниках и владеет им, гиперконвергентно с нагрузкой ВМ. Создайте кластер: первый монитор и его менеджер рождаются автоматически на выбранном узле управления — затем растите его новыми мониторами и устройствами OSD.',
      pageTitle: 'Кластеры Ceph',
      colState: 'Состояние',
      colMembers: 'Участники',
      colSize: 'Размер',
      colVersion: 'Версия Ceph',
      sizeCell: 'занято {used} GiB из {total} GiB',
      phase: {
        'not-deployed': 'Не развернут',
        deploying: 'Развертывание',
        healthy: 'В норме',
        degraded: 'Деградирован',
        error: 'Ошибка',
        destroying: 'Уничтожение',
        destroyed: 'Уничтожен'
      },
      health: {
        HEALTH_OK: 'В норме (HEALTH_OK)',
        HEALTH_WARN: 'С предупреждениями (HEALTH_WARN)',
        HEALTH_ERR: 'В ошибке (HEALTH_ERR)',
        unknown: 'Еще не наблюдалась',
        observedAt: 'наблюдалась {time}'
      },
      create: {
        title: 'Создать кластер Ceph',
        info: 'При создании нового кластера Ceph выбирается первый узел, на который будут установлены роли MON и MGR. Также нужно указать, какая подсеть несет трафик Ceph: публичная подсеть служит для общего сетевого трафика, а подсеть кластера — для внутренних реплик между OSD; разные подсети требуются не обязательно.',
        controlNode: 'Узел управления',
        controlNodeHint: 'Узел-участник, где рождаются первые MON и MGR.',
        publicSubnet: 'Публичная подсеть',
        publicSubnetHint: 'Подсеть, зарегистрированная в IPAM, — public_network Ceph. Неизменяема после создания.',
        clusterSubnet: 'Подсеть кластера',
        clusterSubnetHint: 'Подсеть, зарегистрированная в IPAM, — cluster_network Ceph (репликация и бэкфилл).',
        noSubnets: 'Нет зарегистрированных подсетей — создайте их сначала в IPAM',
        sameSubnet: 'Одна подсеть для публичного трафика и трафика кластера',
        sameSubnetHint: 'Отмечено = сеть кластера (репликация и бэкфилл) совпадает с публичной. Не отмечено = выберите ее подсеть И адрес узла управления внутри нее.',
        controlAddress: 'Адрес узла управления',
        controlAddressHint: 'Адрес, который IPAM знает за этим узлом внутри публичной подсети.',
        controlClusterAddress: 'Кластерный адрес узла управления',
        controlClusterAddressHint: 'Адрес, который IPAM знает за этим узлом внутри подсети кластера.',
        noAddresses: 'IPAM не знает адресов этого узла внутри выбранной подсети',
        started: 'Кластер создан — бутстрап продолжается как макрозадача; фаза обновится сама',
        error: 'Кластер отклонен'
      },
      detail: {
        actions: 'Доступные действия',
        tabOverview: 'Обзор',
        tabManagementNodes: 'MON и MGR',
        tabDisks: 'OSD',
        tabPools: 'Пулы',
        tabObjects: 'Объекты',
        tabCrush: 'Карта CRUSH',
        tabCephfs: 'CephFS',
        tabAdvanced: 'Дополнительно',
        phase: 'Фаза',
        checksTitle: 'Активные проверки работоспособности',
        noChecks: 'Активных проверок работоспособности нет',
        checkMuted: 'заглушено',
        summaryPools: 'Пулы',
        summaryFilesystems: 'Файловые системы',
        nodesCard: 'Узлы',
        monHint: 'MGR работает совмещенно с каждым MON. Три MON — рекомендуемый кворум; лабораторный кластер стартует с одним. OSD и MDS живут на своих вкладках.',
        monHintSplit: 'MON и MGR на этом кластере разделены (Дополнительно): каждая роль — собственное членство на узле. Три MON — рекомендуемый кворум; хотя бы один MGR должен существовать.',
        noMons: 'Мониторы не объявлены',
        addNode: 'Добавить узел',
        removeNode: 'Убрать узел',
        removeNodeFrom: 'Убрать узел {node} (его MON и совмещенный MGR)',
        roleMon: 'Роль MON',
        roleMgr: 'Роль MGR',
        roleNa: 'Н/Д',
        roleNotObserved: 'еще не наблюдалась',
        monInQuorum: 'в кворуме',
        monOutQuorum: 'вне кворума',
        mgrActive: 'активный',
        mgrStandby: 'резервный',
        addRoleMon: 'Добавить роль MON',
        removeRoleMon: 'Убрать роль MON',
        addRoleMgr: 'Добавить роль MGR',
        removeRoleMgr: 'Убрать роль MGR',
        restartMon: 'Перезапустить службу MON',
        restartMgr: 'Перезапустить службу MGR',
        addMon: 'Добавить MON',
        removeMon: 'Убрать MON',
        removeMonFrom: 'Убрать роль MON с узла {node}',
        addMgr: 'Добавить MGR',
        removeMgr: 'Убрать MGR',
        removeMgrFrom: 'Убрать роль MGR с узла {node}',
        addMds: 'Добавить MDS',
        removeMds: 'Убрать MDS',
        removeMdsFrom: 'Убрать роль MDS с узла {node}',
        mdsSection: 'Серверы метаданных (MDS)',
        noMds: 'MDS не объявлены — файловой системе сначала нужен хотя бы один',
        mdsHint: 'Членство MDS собственное с первого дня: кластер без CephFS не объявляет ни одного, один активный плюс один резервный хорошо обслуживают файловую систему. Ceph сам выбирает активных и резервных среди объявленных демонов.',
        mdsActiveFor: 'активный — {fs}',
        mdsNotObserved: 'еще не наблюдался',
        lastMdsGuard: 'Последний MDS нельзя убрать, пока существует файловая система — сначала уберите файловые системы',
        lastMonGuard: 'Последний MON нельзя убрать — уничтожение кластера остается единственным выходом',
        lastMgrGuard: 'Последний MGR нельзя убрать — управляемый кластер никогда не работает без менеджера',
        registerDevice: 'Добавить OSD',
        unregisterDevice: 'Снять с регистрации',
        activeDeviceGuard: 'Активный OSD — он уходит через жизненный цикл OSD, а не через реестр',
        colNode: 'Узел',
        devicePhase: { registered: 'Зарегистрировано', active: 'Активно' },
        health: 'Работоспособность',
        state: 'Состояние',
        fsid: 'fsid',
        fsidPending: 'отсутствует — повторите бутстрап',
        version: 'Версия Ceph',
        publicNetwork: 'Публичная сеть',
        clusterNetwork: 'Сеть кластера',
        clusterNetworkCollapsed: '= публичная',
        noActions: 'В этой фазе нет доступных действий',
        destroyedNote: 'Кластер уничтожен — строка скоро уберется автоматически'
      },
      overview: {
        services: 'Службы',
        ok: 'в норме',
        warning: 'предупреждение',
        down: 'недоступно',
        pgTitle: 'Состояния PG',
        pgTotal: 'всего PG: {n}',
        capacityTitle: 'Пространство',
        ioTitle: 'Текущий ввод-вывод',
        ioReadBw: 'Полоса чтения',
        ioWriteBw: 'Полоса записи',
        ioReadIops: 'IOPS чтения',
        ioWriteIops: 'IOPS записи',
        notObserved: 'еще не наблюдалось'
      },
      osd: {
        colId: 'ID',
        colClass: 'Класс устройства',
        colState: 'Состояние',
        colSize: 'Размер',
        colPgs: 'PG',
        empty: 'Нет ни одного OSD — добавьте его из объявленного диска данных',
        markIn: 'Пометить IN',
        markOut: 'Пометить OUT',
        scrub: 'Выполнить скраб',
        deepScrub: 'Выполнить глубокий скраб',
        restart: 'Перезапустить службу',
        details: 'Детали',
        actionGuard: 'Только на активном OSD развернутого кластера',
        inTitle: 'Пометить OSD как IN',
        inBody: 'osd.{id} возвращается в распределение данных (ceph osd in): Ceph ребалансирует данные на него.',
        outTitle: 'Пометить OSD как OUT',
        outBody: 'osd.{id} выходит из распределения данных (ceph osd out): его данные ребалансируются в другие места, и избыточность СНИЖЕНА, пока идет бэкфилл. Обратимо в любой момент действием «Пометить IN».',
        scrubTitle: 'Запланировать скраб',
        scrubBody: 'Планируется скраб osd.{id}: MON ставит его в очередь, а состояния PG в последующих опросах расскажут об исходе.',
        deepScrubTitle: 'Запланировать глубокий скраб',
        deepScrubBody: 'Планируется глубокий скраб osd.{id}: вариант с проверкой байтов — тяжелее для ввода-вывода, механика та же.',
        restartTitle: 'Перезапустить службу OSD',
        restartBody: 'osd.{id} останавливается и перезапускается под надзором воркера на своем узле.',
        started: 'Действие запущено — наблюдение обновится само',
        error: 'Действие OSD отклонено'
      },
      osdDetail: {
        title: 'Детали OSD',
        tabGeneral: 'Общее',
        tabNetwork: 'Сеть',
        tabDevices: 'Устройства',
        version: 'Версия',
        hostname: 'Имя хоста',
        dataPath: 'Путь к данным OSD',
        objectStore: 'Объектное хранилище OSD',
        encrypted: 'Зашифровано',
        yes: 'Да',
        no: 'Нет',
        memory: 'Использование памяти (PSS)',
        pid: 'Идентификатор процесса (PID)',
        front: 'Внешний адрес (клиенты и мониторы)',
        hbFront: 'Внешний адрес пульса',
        back: 'Внутренний адрес (OSD)',
        hbBack: 'Внутренний адрес пульса',
        colDevice: 'Устройство',
        colType: 'Тип',
        colPhysical: 'Физическое устройство',
        colSize: 'Размер',
        volumeTitle: 'Детали тома',
        creationTime: 'Дата создания',
        lvName: 'Имя LV',
        lvPath: 'Путь LV',
        lvUuid: 'UUID LV',
        vgName: 'Имя VG',
        noDevices: 'Для этого OSD не наблюдалось ни одного устройства'
      },
      restart: {
        title: 'Перезапустить службу',
        monBody: 'Демон MON на узле {node} останавливается и перезапускается под надзором воркера.',
        mgrBody: 'Демон MGR на узле {node} останавливается и перезапускается под надзором воркера.',
        started: 'Перезапуск запущен — наблюдение обновится само',
        error: 'Перезапуск отклонен'
      },
      encryptionMode: {
        alwaysOn: 'Всегда включено (dmcrypt)',
        alwaysOff: 'Всегда выключено',
        perOsd: 'Выбор для каждого OSD',
        section: 'Шифрование OSD в состоянии покоя',
        title: 'Изменить режим шифрования OSD',
        hint: 'Как готовятся НОВЫЕ OSD. Существующие OSD сохраняют свое подисковое состояние: чтобы изменить его, OSD убирают и создают заново.',
        body: 'Режим становится «{mode}» и действует ТОЛЬКО для НОВЫХ OSD: каждый существующий OSD сохраняет свое текущее состояние шифрования.',
        apply: 'Изменить режим',
        error: 'Смена режима отклонена'
      },
      pin: {
        address: 'Публичный адрес (необязательная привязка)',
        clusterAddress: 'Кластерный адрес (необязательная привязка)',
        autoPlaceholder: 'автоматически в подсети {cidr}',
        hint: 'Адресация для каждого демона: пусто = Ceph сам цепляется внутри объявленной сети; заполнено = этот экземпляр привязывается к адресу в своей секции конфигурации.'
      },
      addMon: {
        title: 'Добавить узел',
        node: 'Узел',
        address: 'Публичный адрес',
        addressHint: 'Адреса узла, которые IPAM знает внутри публичной подсети, — автоматически, когда узел покрыт существующим объявлением.',
        clusterAddress: 'Кластерный адрес',
        clusterAddressHint: 'Обязательно: подсеть кластера отдельная, и узел в ней еще не объявлен.',
        noAddresses: 'IPAM не знает адресов этого узла внутри подсети',
        error: 'Добавление MON отклонено'
      },
      removeMon: {
        title: 'Убрать MON',
        body: 'MON и его совмещенный MGR покидают узел {node}. На развернутом кластере демоны останавливаются и выводятся из кворума.',
        error: 'Снятие MON отклонено'
      },
      addMgr: {
        title: 'Добавить MGR',
        node: 'Узел',
        hint: 'Дополнительно (MON и MGR разделены): отдельный менеджер рождается на выбранном узле-участнике задачей с привязкой к узлу. Выборы активного и резервного в Ceph сами определяют активный MGR.',
        error: 'Добавление MGR отклонено'
      },
      removeMgr: {
        title: 'Убрать MGR',
        body: 'Отдельный MGR покидает узел {node}. На развернутом кластере демон останавливается, а его состояние снимается; MON этого узла (если он есть) не затрагивается.',
        error: 'Снятие MGR отклонено'
      },
      addMds: {
        title: 'Добавить MDS',
        node: 'Узел',
        hint: 'Сервер метаданных CephFS: рождается на выбранном узле-участнике задачей с привязкой к узлу, под надзором воркера, как MON и MGR. Ceph сам выбирает активных и резервных — один активный плюс один резервный хорошо обслуживают файловую систему.',
        error: 'Добавление MDS отклонено'
      },
      removeMds: {
        title: 'Убрать MDS',
        body: 'MDS покидает узел {node}. На развернутом кластере демон останавливается, а его состояние снимается; API отказывает в снятии последнего MDS, пока он нужен файловой системе.',
        error: 'Снятие MDS отклонено'
      },
      split: {
        title: 'Разделенные MON и MGR',
        label: 'Разрешить MON и MGR на разных узлах',
        hint: 'Выключено (по умолчанию) = ратифицированный стандарт: MGR работает совмещенно с каждым MON, членство одно. Включено = членство MGR становится собственным и управляется действиями «Добавить MGR» и «Убрать MGR» на вкладке узлов управления.',
        enable: 'Включить',
        disable: 'Выключить',
        enableBody: 'Членство MGR становится независимым от MON и инициализируется текущим совмещением. Действия «Добавить MGR» и «Убрать MGR» появляются на вкладке узлов управления. Это ослабляет платформенное значение по умолчанию — оставляйте его, только если знаете, зачем оно вам.',
        disableBody: 'Возврат к стандартному совмещению: один MGR с каждым MON, членство одно. Допустимо, только если членство MGR уже совпадает с MON — сначала выровняйте его действиями «Добавить MGR» и «Убрать MGR», иначе API откажет.',
        error: 'Изменение отклонено'
      },
      rawEditor: {
        title: 'Сырой редактор CRUSH',
        label: 'Показывать сырой редактор карты CRUSH на вкладке CRUSH',
        hint: 'Выключено (по умолчанию) = управляемая поверхность правил остается стандартным инструментом. Включено = вкладка CRUSH дополнительно показывает декомпилированную карту CRUSH как редактируемый текст. Сохранение всегда требует sudo и имени кластера как подтверждения и проходит через компиляцию и проверку crushtool ДО того, как достигнет кластера.'
      },
      osdFlags: {
        section: 'Глобальные флаги OSD',
        title: 'Переопределение флагов OSD',
        notObserved: 'еще не наблюдались',
        standardFlowsHint: 'Стандартные потоки платформы управляют этими флагами сами в обычных случаях (обслуживание узла ставит точечный noout, замена диска идет через жизненный цикл OSD). Этот раздел — ручное переопределение для оператора, который знает, что делает.',
        notDeployedGuard: 'Флаги OSD существуют только на развернутом кластере',
        set: 'Установить флаг',
        unset: 'Убрать флаг',
        setBody: 'Глобальный флаг {flag} будет УСТАНОВЛЕН в карте OSD. Он держится, пока его явно не уберут — забытый флаг ухудшает самовосстановление кластера.',
        unsetBody: 'Глобальный флаг {flag} будет УБРАН из карты OSD.',
        error: 'Изменение флага отклонено',
        flag: {
          noout: 'Ни один OSD не помечается как out в распределении данных — при потере демона ребалансировки не будет',
          norebalance: 'Ребалансировка данных приостановлена',
          nobackfill: 'Бэкфилл приостановлен',
          norecover: 'Восстановление данных приостановлено',
          pause: 'ВЕСЬ клиентский ввод-вывод приостановлен (чтения и записи)',
          noin: 'Запускающиеся OSD не помечаются как in автоматически',
          nodown: 'Недоступные OSD не помечаются как down — маскирует реальные сбои'
        }
      },
      pools: {
        section: 'Пулы',
        create: 'Создать пул',
        createGuard: 'Пулы существуют только на развернутом кластере',
        notObserved: 'Наблюдений за пулами нет — опрос MON отчитается здесь',
        empty: 'На кластере нет ни одного пула',
        colName: 'Имя',
        colReplication: 'size / min_size',
        colPgNum: 'PG',
        colApplication: 'Приложение',
        colRule: 'Правило CRUSH',
        colUsage: 'Использование',
        observedAtLabel: 'Дата наблюдения',
        objects: 'объектов: {n}',
        inUseBy: 'используется {name}',
        internalGuard: 'Внутренний пул Ceph — платформа никогда его не удаляет',
        delete: 'Удалить пул',
        deleteGuard: 'Потребляется хранилищем {name} — сначала удалите хранилище',
        hint: 'Только реплицированные пулы (избыточное кодирование, EC, вне рамок v1). Репликация живет в Ceph: эта таблица — наблюдаемая правда из опроса MON.',
        createTitle: 'Создать пул',
        createHint: 'Пул рождается на кластере с запрошенной репликацией и включенным приложением rbd — работу выполняет задача на узле MON. Включите «Предложить как хранилище», чтобы тем же жестом сразу его потребить.',
        name: 'Имя пула',
        nameHint: 'Безопасно для DNS (строчные буквы, цифры, дефисы).',
        size: 'Реплики (size)',
        sizeHint: 'Копии каждого объекта. По умолчанию 3.',
        minSize: 'Минимум реплик (min_size)',
        minSizeHint: 'Минимум копий для обслуживания ввода-вывода — следует за size − 1, пока вы это не измените.',
        createError: 'Создание пула отклонено',
        deleteTitle: 'Удалить пул',
        deleteBody: 'Пул {pool} и КАЖДЫЙ объект внутри него уничтожаются необратимо. Введите имя пула для подтверждения.',
        confirmLabel: 'Имя пула',
        confirmHint: 'Введите имя пула для подтверждения',
        deleteError: 'Удаление пула отклонено',
        detailTitle: 'Детали пула',
        autoscaler: 'Автомасштабирование PG',
        autoscalerOn: 'Активно',
        autoscalerOff: 'Не активно',
        autoscalerWarn: 'Уведомление',
        pgNumLabel: 'Число PG',
        pgNumCaption: 'Наблюдаемое значение: автомасштабирование может менять его самостоятельно — это поле записывает пожелание.',
        storage: 'Связанное хранилище TVirt',
        addAsStorage: 'Добавить как хранилище TVirt',
        ruleSudoHint: 'Смена правила CRUSH требует пароля оператора.',
        updateError: 'Изменение пула отклонено',
        updated: 'Изменение пула запущено — наблюдение обновится само'
      },
      crush: {
        section: 'Правила CRUSH',
        notObserved: 'Наблюдений CRUSH пока нет — опрос MON отчитается здесь',
        empty: 'На кластере не наблюдается ни одного правила',
        hint: 'Правило решает, ГДЕ окажутся копии каждого объекта — его домен отказа это единица, которая может выйти из строя без потери данных. Пулы указывают на правило; встроенное replicated_rule (одна реплика на сервер) — правило по умолчанию при рождении.',
        create: 'Создать правило',
        createGuard: 'Правила CRUSH существуют только на развернутом кластере',
        createTitle: 'Создать правило CRUSH',
        createHint: 'Правило = выбор домена отказа. Правило рождается реплицированным на корне по умолчанию — работу выполняет задача на узле MON; пулы свяжете потом на вкладке пулов.',
        createError: 'Создание правила отклонено',
        name: 'Имя правила',
        nameHint: 'Безопасно для DNS (строчные буквы, цифры, дефисы).',
        domain: 'Домен отказа',
        domainChoice: {
          osd: 'Каждая реплика на отдельном OSD',
          host: 'Каждая реплика на отдельном сервере',
          rack: 'Каждая реплика в отдельной стойке'
        },
        domainCustom: 'Пользовательский (шаги написаны вручную)',
        domainOther: 'Каждая реплика в отдельном объекте типа {type}',
        rackGuardHint: 'В наблюдаемой иерархии нет ни одного бакета стойки: правило все равно можно создать, но ни один пул не сможет на него указать, пока стойка не объявлена в размещении серверов-участников (настройки узла) — задача перевыравнивания построит бакет, и связывание откроется само.',
        treeTitle: 'Наблюдаемая иерархия',
        treeNotObserved: 'Наблюдений за иерархией нет — опрос MON отчитается здесь',
        treeOsds: 'OSD: {n}',
        treeHint: 'Карта CRUSH такой, какой ее видит кластер: корень → объявленные уровни → серверы (хосты) → OSD. Топология следует объявленному размещению каждого сервера (настройки узла) — смена размещения перевыравнивает ее задачей.',
        unplacedWarning: 'Участники без объявленного размещения: {nodes} — их хосты остаются прямо под корнем, вне объявленной топологии. Объявите размещение в настройках узла (это предупреждение, а не блокировка).',
        colName: 'Имя',
        colDomain: 'Домен отказа',
        colPools: 'Пулы',
        builtinChip: 'встроенное',
        builtinGuard: 'Правило кластера по умолчанию — платформа никогда его не удаляет',
        detailAction: 'Детали правила',
        detailType: 'Тип',
        backToRules: 'Правила',
        ruleNotObserved: 'В наблюдаемом списке правил это правило не названо',
        noPools: 'Ни один пул не опирается на это правило',
        delete: 'Удалить правило',
        deleteTitle: 'Удалить правило CRUSH',
        deleteBody: 'Правило {rule} убирается из карты CRUSH кластера. На него не должен опираться ни один пул. Введите имя правила для подтверждения.',
        deleteGuard: 'На него опирается пул {name} — сначала перенацельте пул',
        confirmLabel: 'Имя правила',
        confirmHint: 'Введите имя правила для подтверждения',
        deleteError: 'Удаление правила отклонено',
        changeRule: 'Изменить правило CRUSH',
        changeRuleTitle: 'Изменить правило CRUSH',
        changeRuleHint: 'Пул начинает размещать свои объекты по выбранному правилу — Ceph перемещает существующие данные, чтобы им соответствовать (на заполненном пуле следует ребалансировка).',
        changeRuleError: 'Смена правила отклонена',
        rule: 'Правило CRUSH',
        rawTitle: 'Сырая карта CRUSH (декомпилированная)',
        rawWarning: 'ОПАСНО: этот текст — ВСЯ политика размещения кластера. Неверная карта способна сломать размещение сразу всех пулов. Сохранение компилирует и проверяет карту через crushtool ДО внедрения — но и корректная карта может оказаться плохой идеей.',
        rawReload: 'Перезагрузить',
        rawLoading: 'Запрос выполняется — задача только на чтение декомпилирует карту CRUSH…',
        rawSave: 'Сохранить карту CRUSH',
        rawSaveTitle: 'Внедрить карту CRUSH',
        rawSaveBody: 'Измененный текст заменяет карту CRUSH ВСЕГО кластера после компиляции и проверки crushtool. Введите имя кластера для подтверждения.',
        rawConfirmLabel: 'Имя кластера',
        rawConfirmHint: 'Введите {name} для подтверждения',
        rawError: 'Операция с картой CRUSH не удалась',
        rawHint: 'Текст дан в форме crushtool -d. Ошибки компиляции и проверки возвращаются дословно от crushtool — карта не достигнет кластера, если не пройдены оба этих контроля.'
      },
      objects: {
        poolsSection: 'Обозреватель объектов',
        poolsHint: 'Выберите пул, чтобы перечислить его образы RBD. Каждое глубокое чтение выполняется как задача только на чтение на узле MON — оно не блокирует реальные операции и не блокируется ими.',
        deployedGuard: 'Запросы по объектам отвечают только на развернутом кластере',
        browse: 'Просмотреть объекты',
        detailAction: 'Детали образа',
        backToPools: 'Пулы',
        backToImages: 'Образы',
        refresh: 'Обновить',
        loading: 'Запрос выполняется — задача только на чтение опрашивает кластер…',
        error: 'Запрос не удался',
        retry: 'Повторить',
        notRbd: 'Пул с приложением «{app}» — он не содержит образов RBD, здесь нечего исследовать',
        noImages: 'В этом пуле нет образов RBD',
        colImage: 'Образ',
        colSize: 'Размер',
        colObjects: 'Объекты',
        colSnapshots: 'Снимки',
        imagesHint: 'Диски в потребляющем хранилище rbd — это образы, названные по id своего диска. Счетчик объектов показывает выделенное (размер / размер объекта) — реальное использование живет в деталях образа.',
        infoTitle: 'Образ',
        infoSize: 'Виртуальный размер',
        infoObjects: 'Объекты (выделено)',
        infoObjectSize: 'Размер объекта',
        infoPrefix: 'Префикс объектов',
        infoFormat: 'Формат',
        infoFeatures: 'Возможности',
        usageTitle: 'Реальное использование (rbd du)',
        usageOf: 'из {provisioned} GiB выделенных',
        usageHint: 'Тонкое выделение по природе: байты занимают только записанные объекты.',
        watchersTitle: 'Наблюдатели',
        noWatchers: 'Наблюдателей нет — сейчас этот образ никем не открыт',
        snapshotsTitle: 'Снимки RBD',
        noSnapshots: 'На этом образе нет снимков RBD',
        colSnapshot: 'Снимок',
        colProtected: 'Защищен',
        colTimestamp: 'Создан',
        protected: 'защищен',
        mappingTitle: 'Физическое отображение (набор OSD)',
        mappingSampled: 'Выборка: {sampled} объектов из {total} — честная сводка: для больших образов набор сходится ко ВСЕМ OSD пула (CRUSH распределяет объекты по всему пулу).',
        mappingComplete: 'Отображены все объекты ({total} из {total}).',
        objectQueryTitle: 'Отобразить один объект',
        objectName: 'Имя объекта',
        objectHint: 'Имена объектов RADOS имеют вид <префикс>.<16-ричный индекс> — ceph osd map отвечает номером PG и тройками OSD.',
        mapObject: 'Отобразить',
        primary: 'первичный: osd.{osd}'
      },
      registerDevice: {
        title: 'Зарегистрировать устройство OSD',
        hint: 'На живом кластере регистрация еще и ПОДГОТАВЛИВАЕТ устройство: оно становится OSD BlueStore автоматической задачей с привязкой к узлу (никогда не пустой, ратифицировано 2026-07-24). Устройство принадлежит не более чем одному кластеру Ceph во всем парке.',
        disk: 'Диск данных',
        diskHint: 'Объявленные диски данных узла — имя и серийный номер',
        noDeclared: 'На этом узле нет объявленных дисков данных — сначала отметьте их в локальных настройках узла',
        serialHint: 'Серийный номер устройства — привязка идентичности',
        encrypted: 'Шифровать этот OSD (dmcrypt)',
        encryptedHint: 'Выбор для каждого OSD (режим кластера — «выбор для каждого OSD»): он фиксируется на этом диске при регистрации — последующая смена режима никогда его не перезаписывает; это делает строчное действие «зашифровать/расшифровать».',
        error: 'Регистрация отклонена'
      },
      unregisterDevice: {
        title: 'Снять устройство с регистрации',
        body: 'Только реестр: {name} перестает быть кандидатом в OSD этого кластера. Его байты никто не трогает.',
        error: 'Снятие с регистрации отклонено'
      },
      deploy: {
        action: 'Повторить развертывание',
        title: 'Повторить бутстрап',
        body: 'Первоначальный бутстрап начинается заново с текущей конфигурации: MON запускаются, каждое зарегистрированное устройство готовится и активируется как OSD BlueStore. Операция выполняется как макрозадача — фаза обновится сама.',
        started: 'Бутстрап запущен — продолжается как макрозадача; фаза обновится сама',
        error: 'Бутстрап отклонен'
      },
      propose: {
        action: 'Предложить как хранилище',
        title: 'Предложить как хранилище',
        hintPool: 'Существующий пул {name} становится хранилищем TVirt: ограниченная пулом учетная запись cephx попадает в хранилище ключей, и хранилище ceph-rbd рождается готовым. Предложение потребляет пул — оно никогда его не создает.',
        hintFs: 'Существующая файловая система {name} становится хранилищем TVirt: ограниченная файловой системой учетная запись cephx попадает в хранилище ключей, и хранилище cephfs рождается готовым и смонтированным. Предложение потребляет файловую систему — оно никогда ее не создает.',
        name: 'Имя хранилища',
        nameHint: 'DNS-1123, уникальное в скоупе — учетная запись cephx получает имя от него.',
        path: 'Путь внутри файловой системы',
        pathHint: 'Абсолютный путь внутри файловой системы, который монтирует хранилище, — / если сомневаетесь.',
        alsoPropose: 'Сразу предложить как хранилище',
        alsoProposePoolHint: 'После создания тем же жестом только что рожденный пул предлагается как хранилище ceph-rbd — два явных вызова, один диалог.',
        alsoProposeFsHint: 'После создания тем же жестом только что рожденная файловая система предлагается как хранилище cephfs — два явных вызова, один диалог.',
        guard: 'Предложить как хранилище — только на кластере в норме',
        started: 'Предложение принято — хранилище материализуется; ищите его в разделе хранилищ',
        submit: 'Создать хранилище',
        error: 'Предложение отклонено'
      },
      fs: {
        section: 'Файловые системы',
        create: 'Создать файловую систему',
        createGuard: 'Файловые системы существуют только на развернутом кластере',
        mdsFirstGuard: 'Сначала добавьте MDS — файловая система без сервера метаданных рождается непригодной',
        notObserved: 'Наблюдений за файловыми системами нет — опрос MON отчитается здесь',
        empty: 'На кластере нет ни одной файловой системы',
        colName: 'Имя',
        colPools: 'Пулы',
        colMds: 'MDS',
        noActiveMds: 'нет активного MDS',
        delete: 'Убрать файловую систему',
        deleteGuard: 'Потребляется хранилищем {name} — сначала удалите хранилище',
        hint: 'Файловая система владеет своими пулами данных и метаданных (cephfs.<имя>.data / .meta): они рождаются вместе с ней и умирают вместе с ней — removeFs, а не ручное удаление пула. Эта таблица — наблюдаемая правда из опроса MON.',
        createTitle: 'Создать файловую систему',
        createHint: 'Файловая система рождается на кластере со своими двумя пулами (приложение cephfs) и обслуживается объявленными MDS — работу выполняет задача на узле MON. Включите «Предложить как хранилище», чтобы тем же жестом сразу ее потребить.',
        name: 'Имя файловой системы',
        nameHint: 'Безопасно для DNS (строчные буквы, цифры, дефисы).',
        sizeHint: 'Реплики ОБОИХ рождающихся пулов. По умолчанию 3.',
        createError: 'Создание файловой системы отклонено',
        deleteTitle: 'Убрать файловую систему',
        deleteBody: 'Файловая система {fs} и КАЖДЫЙ файл внутри нее уничтожаются необратимо — ее пулы данных и метаданных умирают вместе с ней. Введите имя файловой системы для подтверждения.',
        confirmLabel: 'Имя файловой системы',
        confirmHint: 'Введите имя файловой системы для подтверждения',
        deleteError: 'Снятие файловой системы отклонено'
      },
      destroy: {
        action: 'Уничтожить',
        retryAction: 'Повторить уничтожение',
        retryGuard: 'Уничтожение уже идет — повтор относится к неудавшемуся уничтожению (иначе аренда откажет)',
        title: 'Уничтожить кластер',
        body: 'Развернутая фабрика демонтируется: каждый демон этого кластера останавливается, его системное состояние и ключи в хранилище ключей освобождаются. После успешного уничтожения кластер убирается автоматически.',
        confirmLabel: 'Имя кластера',
        confirmHint: 'Введите имя кластера для подтверждения',
        wipe: 'Стереть зарегистрированные устройства',
        wipeHint: 'Отмечено: подписи каждого зарегистрированного устройства стираются — данные на них уничтожаются. Не отмечено: байты остаются нетронутыми, а устройства возвращаются в состояние зарегистрированных.',
        guard: 'Уничтожить — ничего не развернуто',
        started: 'Уничтожение запущено — продолжается как макрозадача; фаза обновится сама',
        error: 'Уничтожение отклонено'
      },
      delete: {
        guard: 'Удалить — только неразвернутую конфигурацию (сначала уничтожьте)',
        title: 'Удалить {name}?',
        body: 'Конфигурация и ее реестр устройств убираются. Допустимо, только пока ничего не развернуто.',
        error: 'Удаление отклонено'
      }
    }
  }
}
